module.exports = __webpack_public_path__ + "img/green-travel.c019e04a.jpg";